module.exports = __webpack_public_path__ + "static/media/signup-main.b53584e3.jpg";